export const radii = {
  'radius-none': '0px',
  'radius-xxs': '2px',
  'radius-xs': '4px',
  'radius-sm': '6px',
  'radius-md': '8px',
  'radius-lg': '10px',
  'radius-xl': '12px',
  'radius-2xl': '16px',
  'radius-3xl': '20px',
  'radius-4xl': '24px',
  'radius-5xl': '32px',
  'radius-full': '9999px',
} as const
